<template>
  <div class="w-100 px-5 py-4">
    <div id="TituloSalaVirtual_div" class="w-100">
      <h1>Datos Personales</h1>
      <h3>Editar Empleado</h3>
    </div>
    <div style="display: flex">
      <div class="col-12 padding-div-low">
        <ul class="nav nav-tabs" id="tabAltaUsuario" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="personales-tab" data-toggle="tab" href="#personales" role="tab" aria-controls="personales" aria-selected="true">Personales</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="academicos-tab" data-toggle="tab" href="#academicos" role="tab" aria-controls="academicos" aria-selected="false">Academicos</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="laborales-tab" data-toggle="tab" href="#laborales" role="tab" aria-controls="laborales" aria-selected="false">Laborales</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="superior-tab" data-toggle="tab" href="#superior" role="tab" aria-controls="superior" aria-selected="false">Superior</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="familiares-tab" data-toggle="tab" href="#familiares" role="tab" aria-controls="familiares" aria-selected="false">Familiares</a>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <!--Contenido del tabulador Personales-->
          <div class="tab-pane fade show active" id="personales" role="tabpanel" aria-labelledby="personales-tab">
            <div class="row">
              <div class="col-2 padding-div-low text-center">
                <i class="fas fa-user-tie prof-pic"></i>
              </div>
              <div class="col-10 padding-div-low">
                <div class="form-group area">
                  <!--Nombre, Apellido paterno, Apellido materno-->
                  <div class="row">
                    <div class="form-group-h col-4">
                      <input id="nombrePersona" name="nombrePersona" class="form-control" placeholder="Nombre" value="Lillian">
                    </div>
                    <div class="form-group-h col-4">
                      <input id="apellidoPaterno" name="apellidoPaterno" class="form-control" placeholder="Apellido Paterno" value="González">
                    </div>
                    <div class="form-group-h col-4">
                      <input id="apellidoMaterno" name="apellidoMaterno" class="form-control" placeholder="Apellido Materno" value="Frías">
                    </div>
                  </div>
                  <!--Correo electrónico, RFC, CURP-->
                  <div class="row">
                    <div class="form-group-h col-4">
                      <input id="nombrePersona" name="nombrePersona" class="form-control" placeholder="Correo Electrónico" value="lillian.gonzalez@poderjudicialags.gob.mx">
                    </div>
                    <div class="form-group-h col-4">
                      <input id="apellidoPaterno" name="apellidoPaterno" class="form-control" placeholder="RFC" value="GOFL19970216HY5">
                    </div>
                    <div class="form-group-h col-4">
                      <input id="apellidoMaterno" name="apellidoMaterno" class="form-control" placeholder="CURP" value="GOFL19970216MASNDC01">
                    </div>
                  </div>
                  <!--Numero de seguro social, Estado civil, Numero de nomina-->
                  <div class="row">
                    <div class="form-group-h col-4">
                      <input id="numeroSeguroSocial" name="numeroSeguroSocial" class="form-control" placeholder="Número de Seguro Social" value="H3436987HGE3">
                    </div>
                    <div class="form-group-h col-4">
                      <!--<label for="exampleFormControlSelect1">Estado Civil</label>-->
                      <select class="form-control" id="">
                        <option>Estado Civil</option>
                        <option selected>Soltero/a</option>
                        <option>Casado/a</option>
                        <option>Viudo/a</option>
                      </select>
                      <!--<input id="estadoCivil" name="estadoCivil" class="form-control" placeholder="Estado Civil">-->
                    </div>
                    <div class="form-group-h col-4">
                      <input id="numeroNomina" name="numeroNomina" class="form-control" placeholder="Número de Nómina" value="43543574398">
                    </div>
                  </div>
                  <!--Sexo, Fecha de nacimiento-->
                  <div class="row">
                    <div class="form-group-h col-4">
                      <select class="form-control" id="exampleFormControlSelect1">
                        <option>Sexo</option>
                        <option>Masculino</option>
                        <option selected>Femenino</option>
                      </select>
                    </div>
                    <div class="form-group-h col-4">
                      <label for="">Fecha de nacimiento: </label>
                      <input id="fechaNacimientoPersona" name="fechaNacimientoPersona" type="date" class="form-control" value="1997-02-16" />
                    </div>
                  </div>
                  <!--Pais de nacimiento, Entidad federativa de nacimiento, Municipio de nacimiento-->
                  <div class="row">
                    <div class="form-group-h col-4">
                      <select class="form-control" id="">
                        <option>País de nacimiento</option>
                        <option selected>México</option>
                        <option>Otro</option>
                      </select>
                    </div>
                    <div class="form-group-h col-4">
                      <select class="form-control" id="">
                        <option>Entidad Federativa de nacimiento</option>
                        <option selected>Aguascalientes</option>
                        <option>Baja California</option>
                      </select>
                    </div>
                    <div class="form-group-h col-4">
                      <select class="form-control" id="">
                        <option>Municipio de nacimiento</option>
                        <option selected>Aguascalientes</option>
                        <option>Calvillo</option>
                      </select>
                    </div>
                  </div>
                  <!--Teléfono 1(celular), Telefono 2(casa) y Teléfono 3(otro)-->
                  <div class="row">
                    <div class="form-group-h col-4">
                      <input id="telefonoDeCelular" name="telefonoDeCelular" class="form-control" placeholder="Teléfono (celular)" value="4496181290">
                    </div>
                    <div class="form-group-h col-4">
                      <input id="telefonoDeCasa" name="telefonoDeCasa" class="form-control" placeholder="Teléfono (casa)" value="9791774">
                    </div>
                    <div class="form-group-h col-4">
                      <input id="telefonoOtro" name="telefonoOtro" class="form-control" placeholder="Teléfono (otro)">
                    </div>
                  </div>
                  <h5>Domicilio</h5>
                  <!--Pais, Estado, Municipio, Calle-->
                  <div class="row">
                    <div class="form-group-h col-3">
                      <select class="form-control" id="paisDeDomicilio">
                        <option>País</option>
                        <option selected>México</option>
                        <option>Otro</option>
                      </select>
                    </div>
                    <div class="form-group-h col-3">
                      <select class="form-control" id="entidadFederativaDeDomicilio">
                        <option>Estado</option>
                        <option selected>Aguascalientes</option>
                        <option>Baja California</option>
                      </select>
                    </div>
                    <div class="form-group-h col-3">
                      <select class="form-control" id="municipioDeDomicilio">
                        <option>Municipio</option>
                        <option selected>Aguascalientes</option>
                        <option>Calvillo</option>
                      </select>
                    </div>
                    <div class="form-group-h col-3">
                      <input id="calleDeDomicilio" name="calleDeDomicilio" class="form-control" placeholder="Calle" value="Salto de Los Salado">
                    </div>
                  </div>
                  <!--Numero Exterior, Numero interior, Colonia/Fraccionamiento, C.P.-->
                  <div class="row">
                    <div class="form-group-h col-3">
                      <input id="numeroExterior" name="numeroExterior" class="form-control" placeholder="Num. Exterior" value="134">
                    </div>
                    <div class="form-group-h col-3">
                      <input id="numeroInterior" name="numeroInterior" class="form-control" placeholder="Num. Interior">
                    </div>
                    <div class="form-group-h col-3">
                      <input id="coloniaFraccionamiento" name="coloniaFraccionamiento" class="form-control" placeholder="Colonia/Fraccionamiento" value="Ojocaliente 1">
                    </div>
                    <div class="form-group-h col-3">
                      <input id="codigoPostal" name="codigoPostal" class="form-control" placeholder="Código Postal" value="20250">
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-3">
                      <router-link to="/SIAP/ConsultaPersonal">
                        <button v-on:click="" id="btnGuardaAvance" class="btn btn-primary">Guardar</button>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!--Contenido del tabulador Academicos-->
          <div class="tab-pane fade" id="academicos" role="tabpanel" aria-labelledby="academicos-tab">
            <div class="row">
              <div class="col-2 padding-div-low text-center">
                <i class="fas fa-user-tie prof-pic"></i>
              </div>
              <div class="col-10 padding-div-low">
                <div class="form-group area">
                  <!--Nivel Academico, Nombre de la institución, Fecha inicial, Fecha final-->
                  <div class="row">
                    <div class="form-group-h col-3">
                      <select class="form-control" id="nivelAcademico">
                        <option>Nivel Académico</option>
                        <option>Primaria</option>
                        <option>Secundaria</option>
                        <option>Preparatoria</option>
                      </select>
                    </div>
                    <div class="form-group-h col-3">
                      <input id="nombreDeInstitucion" name="nombreDeInstitucion" class="form-control" placeholder="Nombre de la institución">
                    </div>
                    <div class="form-group-h col-3">
                      <label for="">Fecha Inicial: </label>
                      <input id="fechaInicialNivelAcademico" name="fechaInicialNivelAcademico" type="date" class="form-control" />
                    </div>
                    <div class="form-group-h col-3">
                      <label for="">Fecha Final: </label>
                      <input id="fechaFinalNivelAcademico" name="fechaFinalNivelAcademico" type="date" class="form-control" />
                    </div>
                  </div>
                  <!--nombre titulo, documento entregado-->
                  <div class="row">
                    <div class="form-group-h col-3">
                      <select class="form-control" id="nombreDeTitulo">
                        <option>Nombre del título</option>
                        <option>Técnico Superior Universitario</option>
                        <option>Licenciatura</option>
                        <option>Maestría</option>
                      </select>
                    </div>
                    <div class="form-group-h col-3">
                      <select class="form-control" id="documentoEntregado">
                        <option>Documento Entregado</option>
                        <option>Certificado</option>
                        <option>Diploma</option>
                        <option>Título Profesional</option>
                      </select>
                    </div>
                  </div>
                  <!--boton agregar y guardar-->
                  <div class="row">
                    <div class="form-group col-3">
                      <button v-on:click="" id="btnAgregar" class="btn btn-primary">Agregar</button>
                      <button v-on:click="" id="btnGuardaAvance" class="btn btn-primary">Guardar</button>
                    </div>
                  </div>
                </div>
                <hr />
                <h5>Historial Académico</h5>
                <table class="table table-striped table-light table-hover" id="tablaHistorialAcademico">
                  <thead class="thead-custom">
                    <tr>
                      <th class="text-center">Periodo</th>
                      <th class="text-center">Nivel Académico</th>
                      <th class="text-center">Institución</th>
                      <th class="text-center">Título</th>
                      <th class="text-center">Documento Entregado</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="academico in academicos">
                      <td class="text-center">
                        {{academico.Periodo}}
                      </td>
                      <td class="text-center">
                        {{academico.NivelAcademico}}
                      </td>
                      <td class="text-center">
                        {{academico.Institucion}}
                      </td>
                      <td class="text-center">
                        {{academico.Titulo}}
                      </td>
                      <td class="text-center">
                        {{academico.DocumentoEntregado}}
                      </td>
                      <td class="text-center">
                        <i class="fas fa-edit"></i>
                        <i class="fas fa-trash" @click="borrarFila"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!--Contenido del tabulador Laborales-->
          <div class="tab-pane fade" id="laborales" role="tabpanel" aria-labelledby="laborales-tab">
            <div class="row">
              <div class="col-2 padding-div-low text-center">
                <i class="fas fa-user-tie prof-pic"></i>
              </div>
              <div class="col-10 padding-div-low">
                <div class="form-group area">
                  <!--Seccion, Departamento, Puesto, Tipo de Puesto-->
                  <div class="row">
                    <div class="form-group-h col-3">
                      <select class="form-control" id="seccionLaboral">
                        <option>Sección</option>
                      </select>
                    </div>
                    <div class="form-group-h col-3">
                      <select class="form-control" id="departamentoLaboral">
                        <option>Departamento</option>
                      </select>
                    </div>
                    <div class="form-group-h col-3">
                      <select class="form-control" id="puestoLaboral">
                        <option>Puesto</option>
                      </select>
                    </div>
                    <div class="form-group-h col-3">
                      <select class="form-control" id="tipoDePuesto">
                        <option>Tipo de puesto</option>
                      </select>
                    </div>
                  </div>
                  <!--Fecha Inicial, Fecha final, Tipo de Movimiento-->
                  <div class="row">
                    <div class="form-group-h col-3">
                      <label for="">Fecha Inicial: </label>
                      <input id="fechaInicialPeriodoLaboral" name="fechaInicialPeriodoLaboral" type="date" class="form-control" />
                    </div>
                    <div class="form-group-h col-3">
                      <label for="">Fecha Final: </label>
                      <input id="fechaFinalPeriodoLaboral" name="fechaFinalPeriodoLaboral" type="date" class="form-control" />
                    </div>
                    <div class="form-group-h col-3">
                      <select class="form-control" id="tipoDeMovimiento">
                        <option>Tipo de Movimiento</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-3">
                      <button v-on:click="" id="btnAgregar" class="btn btn-primary">Agregar</button>
                      <button v-on:click="" id="btnGuardaAvance" class="btn btn-primary">Guardar</button>
                    </div>
                  </div>
                </div>
                <hr />
                <h5>Historial Laboral</h5>
                <table class="table table-striped table-light table-hover" id="tablaHistorialLaboral">
                  <thead class="thead-custom">
                    <tr>
                      <th class="text-center">Periodo</th>
                      <th class="text-center">Área</th>
                      <th class="text-center">Departamento</th>
                      <th class="text-center">Puesto</th>
                      <th class="text-center">Tipo Movimiento</th>
                      <th class="text-center">Tipo Plaza</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="laboral in laborales">
                      <td class="text-center">
                        {{laboral.Periodo}}
                      </td>
                      <td class="text-center">
                        {{laboral.Area}}
                      </td>
                      <td class="text-center">
                        {{laboral.Departamento}}
                      </td>
                      <td class="text-center">
                        {{laboral.Puesto}}
                      </td>
                      <td class="text-center">
                        {{laboral.TipoDeMovimiento}}
                      </td>
                      <td class="text-center">
                        {{laboral.TipoDePlaza}}
                      </td>
                      <td class="text-center">
                        <i class="fas fa-edit"></i>
                        <i class="fas fa-trash" @click="borrarFila"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!--Contenido del tabulador Superior-->
          <div class="tab-pane fade" id="superior" role="tabpanel" aria-labelledby="superior-tab">
            <div class="row">
              <div class="col-2 padding-div-low text-center">
                <i class="fas fa-user-tie prof-pic"></i>
              </div>
              <div class="col-10 padding-div-low">
                <div class="form-group area">
                  <!--Nivel Academico, Nombre de la institución, Fecha inicial, Fecha final-->
                  <div class="row">
                    <div class="col-6">
                      <input type="text" class="form-control" placeholder="Nombre" />
                    </div>
                    <div class="col-6">
                      <select class="form-control">
                        <option selected disabled>Area</option>
                      </select>
                    </div>
                  </div>
                  <div class="row" style="margin-top:10px;">
                    <div class="col-6">
                      <select class="form-control">
                        <option selected disabled>Departamento</option>
                      </select>
                    </div>
                    <div class="col-6">
                      <select class="form-control">
                        <option selected disabled>Puesto</option>
                      </select>
                    </div>
                  </div>
                  <!--nombre titulo, documento entregado-->
                  <!--boton agregar y guardar-->
                  <div class="row" style="margin-top:20px;">
                    <div class="col-9"></div>
                    <div class="col-3">
                      <input type="button" class="form-control" value="Buscar" />
                    </div>
                  </div>
                </div>
                <hr />
                <h5>Resultados</h5>
                <table class="table table-striped table-light table-hover">
                  <thead class="thead-custom">
                    <tr>
                      <th></th>
                      <th class="text-center">ID Persona</th>
                      <th class="text-center">Nombre</th>
                      <th class="text-center">Area</th>
                      <th class="text-center">Departamento</th>
                      <th class="text-center">Puesto</th>
                      <th class="text-center">Tipo de Puesto</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="academico in academicos">
                      <td class="text-center">
                        <input type="radio" name="superior" />
                      </td>
                      <td class="text-center">
                        457
                      </td>
                      <td class="text-center">
                        Jose Juan Hernandez Huel
                      </td>
                      <td class="text-center">
                        Juzgados Familiares
                      </td>
                      <td class="text-center">
                        Juzgado 1ro Familiar
                      </td>
                      <td class="text-center">
                        Juez
                      </td>
                      <td class="text-center">
                        De Base
                      </td>

                    </tr>
                    <tr v-for="academico in academicos">
                      <td class="text-center">
                        <input type="radio" name="superior" />
                      </td>
                      <td class="text-center">
                        724
                      </td>
                      <td class="text-center">
                        Marco Antonio Gutierrez Tapia
                      </td>
                      <td class="text-center">
                        Juzgados Familiares
                      </td>
                      <td class="text-center">
                        Juzgado 3ro Familiar
                      </td>
                      <td class="text-center">
                        Juez
                      </td>
                      <td class="text-center">
                        De Base
                      </td>

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!--Contenido del tabulador Familiares-->
          <div class="tab-pane fade" id="familiares" role="tabpanel" aria-labelledby="familiares-tab">
            <div class="row">
              <div class="col-2 padding-div-low text-center">
                <i class="fas fa-user-tie prof-pic"></i>
              </div>
              <div class="col-10 padding-div-low">
                <div class="form-group area">
                  <!--Nombre, ApellidoPaterno, Apellido Materno, Fecha de nacimiento-->
                  <div class="row">
                    <div class="form-group-h col-3">
                      <input id="nombreDeFamiliar" name="nombreDeFamiliar" class="form-control" placeholder="Nombre">
                    </div>
                    <div class="form-group-h col-3">
                      <input id="apellidoPaternoDeFamiliar" name="apellidoPaternoDeFamiliar" class="form-control" placeholder="Apellido Paterno">
                    </div>
                    <div class="form-group-h col-3">
                      <input id="apellidoMaternoDeFamiliar" name="apellidoMaternoDeFamiliar" class="form-control" placeholder="Apellido Materno">
                    </div>
                    <div class="form-group-h col-3">
                      <label for="">Fecha de nacimiento: </label>
                      <input id="fechaNacimientoDeFamiliar" name="fechaNacimientoDeFamiliar" type="date" class="form-control" />
                    </div>
                  </div>
                  <!--Parentesco, Dependiente Economico, Telefono-->
                  <div class="row">
                    <div class="form-group-h col-3">
                      <select class="form-control" id="tipoDeParentesco">
                        <option>Parentesco</option>
                      </select>
                    </div>
                    <div class="form-group-h col-3">
                      <input id="dependienteEconomico" type="checkbox" class="form-check-input">
                      <label for="dependienteEconomico" class="form-check-label">Dependiente Económico</label>
                    </div>
                    <div class="form-group-h col-3">
                      <input id="telefonoDeFamiliar" name="telefonoDeFamiliar" class="form-control" placeholder="Teléfono">
                    </div>
                  </div>
                  <!--botones de agregar y guardar-->
                  <div class="row">
                    <div class="form-group col-3">
                      <button v-on:click="" id="btnAgregar" class="btn btn-primary">Agregar</button>
                      <button v-on:click="" id="btnGuardaAvance" class="btn btn-primary">Guardar</button>
                    </div>
                  </div>
                  <h5>Domicilio</h5>
                  <!--Pais, Estado, Municipio, Calle-->
                  <div class="row">
                    <div class="form-group-h col-3">
                      <select class="form-control" id="paisDeDomicilioDelFamiliar">
                        <option>País de nacimiento</option>
                        <option>México</option>
                        <option>Otro</option>
                      </select>
                    </div>
                    <div class="form-group-h col-3">
                      <select class="form-control" id="entidadDeDomicioDelFamiliar">
                        <option>Entidad Federativa</option>
                        <option>Aguascalientes</option>
                        <option>Baja California</option>
                      </select>
                    </div>
                    <div class="form-group-h col-3">
                      <select class="form-control" id="municipioDeDomicilioDelFamiliar">
                        <option>Municipio</option>
                        <option>Aguascalientes</option>
                        <option>Calvillo</option>
                      </select>
                    </div>
                    <div class="form-group-h col-3">
                      <input id="calleDeFamiliar" name="calleDeFamiliar" class="form-control" placeholder="Calle">
                    </div>
                  </div>
                  <!--Numero exterior, Numero Interior, Colonia/Fraccionamiento, Codigo postal-->
                  <div class="row">
                    <div class="form-group-h col-3">
                      <input id="numeroExteriorDeFamiliar" name="numeroExteriorDeFamiliar" class="form-control" placeholder="Num. Exterior">
                    </div>
                    <div class="form-group-h col-3">
                      <input id="numeroInteriorDeFamiliar" name="numeroInteriorDeFamiliar" class="form-control" placeholder="Num. Interior">
                    </div>
                    <div class="form-group-h col-3">
                      <input id="coloniaFraccionamientoDeFamiliar" name="coloniaFraccionamientoDeFamiliar" class="form-control" placeholder="Colonia/Fraccionamiento">
                    </div>
                    <div class="form-group-h col-3">
                      <input id="codigoPostalDeFamiliar" name="codigoPostalDeFamiliar" class="form-control" placeholder="Código Postal">
                    </div>
                  </div>
                </div>
                <hr />
                <h5>Datos Familiares</h5>
                <table class="table table-striped table-light table-hover" id="tablaFamiliares">
                  <thead class="thead-custom">
                    <tr>
                      <th class="text-center">Nombre</th>
                      <th class="text-center">Apellido Paterno</th>
                      <th class="text-center">Apellido Materno</th>
                      <th class="text-center">Parentesco</th>
                      <th class="text-center">Dependiente Economico</th>
                      <th class="text-center">Fecha Nacimiento</th>
                      <th class="text-center">Domicilio</th>
                      <th class="text-center">Acciones</th>
                    </tr>
                  </thead>
                  <tbody class="text-dark">
                    <tr v-for="familia in familiares">
                      <td class="text-center">
                        {{familia.Nombre}}
                      </td>
                      <td class="text-center">
                        {{familia.ApellidoPaterno}}
                      </td>
                      <td class="text-center">
                        {{familia.ApellidoMaterno}}
                      </td>
                      <td class="text-center">
                        {{familia.Parentesco}}
                      </td>
                      <td class="text-center">
                        {{familia.DependienteEconomico}}
                      </td>
                      <td class="text-center">
                        {{familia.FechaNacimiento}}
                      </td>
                      <td class="text-center">
                        {{familia.Domicilio}}
                      </td>
                      <td class="text-center">
                        <i class="fas fa-edit"></i>
                        <i class="fas fa-trash" @click="borrarFila"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //import Layout from '@/components/SIAP/Comun/Plantilla.vue';
  import catalogos from '@/../static/js/catalogos'
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
     props: ['idPersona'],
    data() {
      return {
        academicos: [
          { Periodo: '01/06/1997 - 01/06/2003', NivelAcademico: 'Primaria', Institucion: "Niños Héroes", Titulo: 'Educación básica', DocumentoEntregado: 'Certificado de estudios' }
        ],
        laborales: [
          { Periodo: '01/06/1997 - 01/06/2003', Area: 'Juzgados Mercantiles', Departamento: "Juzgado Cuarto de lo Mercantil", Puesto: 'Juez', TipoDeMovimiento: 'Ingreso al Poder Judicial', TipoDePlaza: 'Base' }
        ],
        familiares: [
          { Nombre: 'Mateo', ApellidoPaterno: 'Romo', ApellidoMaterno: "Romo", Parentesco: 'Esposo', DependienteEconomico: 'Sí', FechaNacimiento: '01/01/2000', Domicilio: "Pueblito 123, Col. San Marcos, Aguascalientes, Aguascalientes" }
        ]
      }
    },
    components: {
      //Layout
    },
    methods: {
      borrarFila: function (event) {
        var boton = event.target
        var row = boton.parentElement.parentElement;
        if (row.tagName == "TR") {
          row.remove();
        }
      }
    }, mounted: function () {
      alert(this.idPersona)
    }

  }
</script>

<style scoped>
  .prof-pic {
    font-size: 150px;
    max-width: 400px;
  }

  .tab-content {
    padding-top: 15px;
  }
  .thead-custom {
  background-color: #004746;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/SIAP/AdministracionPersonal/EditarUsuario.vue